// libraries
import clsx from 'clsx'

// css
import './index.scss'

// types
interface Props {
    className?: string
    children?: string
}

export default function RichText({
    className,
    children
}: Props) {
    return (
        <div
            className={clsx('rich-text', className)}
            dangerouslySetInnerHTML={{ __html: children || '' }}
            suppressHydrationWarning
        />
    )
}